import React, { useEffect, useRef, useState } from "react";
import { getPageContents } from "../../services/apiOtherlink";

const Advertisement = () => {
  const [AdvertisementContent, setAdvertisementContent] = useState('');
  useEffect(() => {
      fetchContent()
    }, [])
 
    const fetchContent = async () => {
        let content = await getPageContents();
       
         setAdvertisementContent(content.advertisementPolicy.template)
    
      }

  
  return (
   <div>
  <div className="hd-breadcums">
    <h3 className="main-heading">Dreamers Health Advertisement Policy</h3>
  </div>
 <div className="succ-content" dangerouslySetInnerHTML={{ __html: AdvertisementContent}} /> 
  <style>{`
        .tc { list-style: none; padding-left: 0; }
        .mt-3 { margin-top: 1rem; }
        .sub-t-c { margin-top: 0.25rem; }
        ul.tc li ol li {
    list-style: auto;
        margin-bottom: 10px;
}
        ul.tc ol {
    padding-left: 16px !important;
    margin-bottom: 0px;
}
      `}</style>
</div>


  );
};
export default Advertisement;